<main class="auth-page">
  <section class="auth-card">
    <div class="brand-mark">
      <mat-icon>settings_suggest</mat-icon>
    </div>
    <h1>Reset Password</h1>
    <p *ngIf="!loading && validToken">Create a new secure password for {{ email }}.</p>
    <p *ngIf="loading">Validating your reset link...</p>

    <div class="error-alert state-message" *ngIf="!loading && !validToken">
      <span class="error-icon"><mat-icon>priority_high</mat-icon></span>
      <div>
        <strong>Reset link failed</strong>
        <p>{{ error }}</p>
      </div>
    </div>
    <a class="back-link" *ngIf="!loading && !validToken" routerLink="/forgot-password">Request a new reset link</a>

    <form *ngIf="!loading && validToken" (ngSubmit)="submit()">
      <label>
        <span>New Password</span>
        <span class="input-shell">
          <mat-icon>lock</mat-icon>
          <input
            name="password"
            [type]="showPassword ? 'text' : 'password'"
            [(ngModel)]="password"
            autocomplete="new-password"
            required
            minlength="8"
            maxlength="64"
          />
          <button
            type="button"
            class="visibility-toggle"
            aria-label="Hold to show password"
            (mousedown)="reveal('password', true)"
            (mouseup)="reveal('password', false)"
            (mouseleave)="reveal('password', false)"
            (touchstart)="reveal('password', true)"
            (touchend)="reveal('password', false)"
          >
            <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </span>
      </label>

      <label>
        <span>Confirm Password</span>
        <span class="input-shell">
          <mat-icon>verified_user</mat-icon>
          <input
            name="confirmPassword"
            [type]="showConfirmPassword ? 'text' : 'password'"
            [(ngModel)]="confirmPassword"
            autocomplete="new-password"
            required
            minlength="8"
            maxlength="64"
          />
          <button
            type="button"
            class="visibility-toggle"
            aria-label="Hold to show confirm password"
            (mousedown)="reveal('confirm', true)"
            (mouseup)="reveal('confirm', false)"
            (mouseleave)="reveal('confirm', false)"
            (touchstart)="reveal('confirm', true)"
            (touchend)="reveal('confirm', false)"
          >
            <mat-icon>{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </span>
      </label>

      <ul class="rules">
        <li>At least 8 characters</li>
        <li>Uppercase, lowercase, number, and special character</li>
      </ul>

      <div class="error-alert" *ngIf="error">
        <span class="error-icon"><mat-icon>priority_high</mat-icon></span>
        <div>
          <strong>Reset failed</strong>
          <p>{{ error }}</p>
        </div>
      </div>
      <button class="auth-btn" type="submit" [disabled]="submitting">{{ submitting ? 'Resetting...' : 'Reset Password' }}</button>
      <a class="back-link" routerLink="/login">Back to login</a>
    </form>
  </section>
</main>
